import React, { useState } from 'react';
import { Box, List, ListItem, ListItemIcon, Typography, IconButton, Slide, Stack } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useThemeContext } from '../../../hook/useThemeManager';
import { theme } from '../../../constants/theme';
import { FONT_ENUM } from '../../../types/global/fonts.types';
import CustomLazyLoadImage from '../../Image/CustomLazyLoadImage';

interface Setting {
    title: string;
    options: string[];
    icon: string;
}

type ChangePayload = {
    optionTitle: string;
    option: string;
};

export interface SettingsComponentProps {
    settings: Setting[];
    onChangeOption?: (arg: ChangePayload) => void;
    initialValue?: ChangePayload;
}

export const SettingsComponent: React.FC<SettingsComponentProps> = ({ settings, onChangeOption }) => {
    const [selectedSetting, setSelectedSetting] = useState<Setting | null>(null);
    const { themeStyle } = useThemeContext();
    const [option, setOption] = useState({
        title: '',
        selectedOption: '',
    });

    const handleSettingClick = (setting: Setting) => {
        setSelectedSetting(setting);
        setOption({
            title: setting.title,
            selectedOption: '',
        });
    };

    const handleBackClick = () => {
        setSelectedSetting(null);
    };

    const handleSelectOption = (o: string) => {
        setOption(prevState => ({
            ...prevState,
            selectedOption: o,
        }));

        onChangeOption && onChangeOption({ option: o, optionTitle: option.title });
    };

    return (
        <Box
            sx={{
                backgroundColor: theme[themeStyle].deep_grey,
                borderRadius: 3,
                padding: 1,
            }}>
            {!selectedSetting ? (
                <List>
                    {settings.map((setting, index) => (
                        <ListItem key={index} onClick={() => handleSettingClick(setting)}>
                            <ListItemIcon sx={{ minWidth: '30px' }}>
                                <CustomLazyLoadImage
                                    src={setting.icon}
                                    alt="Icon"
                                    style={{ height: '20px', width: '20px' }}
                                />
                            </ListItemIcon>
                            <Typography
                                style={{
                                    fontFamily: FONT_ENUM.REGULAR_HEADER,
                                    fontSize: 12,
                                    textTransform: 'capitalize',
                                    color: theme[themeStyle].tag_white,
                                }}>
                                {setting.title}
                            </Typography>
                        </ListItem>
                    ))}
                </List>
            ) : (
                <Slide direction="left" in={!!selectedSetting} mountOnEnter unmountOnExit>
                    <Box sx={{ minWidth: '150px' }}>
                        <Stack direction="row" alignItems="center">
                            <IconButton onClick={handleBackClick}>
                                <ArrowBackIcon sx={{ color: '#fff' }} />
                            </IconButton>
                            <Typography
                                style={{
                                    fontFamily: FONT_ENUM.REGULAR_HEADER,
                                    fontSize: 12,
                                    textTransform: 'capitalize',
                                    color: theme[themeStyle].tag_white,
                                }}>
                                {selectedSetting.title}
                            </Typography>
                        </Stack>
                        <List>
                            {selectedSetting.options.map((option, index) => (
                                <ListItem key={index} onClick={() => handleSelectOption(option)}>
                                    <Typography
                                        style={{
                                            fontFamily: FONT_ENUM.REGULAR_HEADER,
                                            fontSize: 12,
                                            textTransform: 'capitalize',
                                            color: theme[themeStyle].tag_white,
                                        }}>
                                        {option}
                                    </Typography>
                                </ListItem>
                            ))}
                        </List>
                    </Box>
                </Slide>
            )}
        </Box>
    );
};
